import Field from '@base/Form/Field';
import { InputAdornment } from '@material-ui/core';
import CountryMenu from '@cont/Login/CountryMenu';
import { useEffect, useState } from 'react';
import {
  checkAlphabetic,
  isLengthMatchError,
  isRequired,
  isValidName,
  isImageTypeValid,
  isImageSizeValid,
  isNumericOnlyError,
  isIdLengthValidError
} from './utils';
import {
  Error,
  FieldWrapper,
  FormContainer,
  FormSectionHeading,
  StyledNumberField,
  StyledTextField,
  StyledDropdown,
  FormSectionSubHeading,
  FieldWrapperSmall
} from './styles';
import { parentIdTypes } from '../constants';
import FileUploader from './FileUploader';

const renderErrorMessage = ({ message }) => {
  return <Error>{message}</Error>;
};

const ParentDetails = ({ registrar, country, updateStoreData }) => {
  const parentIdTypeValue = registrar.data.parentIdType?.value;
  const [parentIdType, setParentIdType] = useState(parentIdTypeValue);

  useEffect(() => {
    setParentIdType(parentIdTypeValue);
  }, [parentIdTypeValue]);

  return (
    <FormContainer>
      <FormSectionHeading>Parent/Guardian details</FormSectionHeading>
      <FieldWrapper>
        <Field
          registrar={registrar}
          name="parentFullName"
          rules={[
            isRequired('Name is required'),
            isValidName('Please enter a valid name', 150)
          ]}
          render={({ onChange, value, hasError }) => (
            <StyledTextField
              placeholder="Enter full name"
              value={value}
              onChange={(data) => {
                if (checkAlphabetic(onChange, data, true)) {
                  updateStoreData('parentFullName', data.target.value);
                }
              }}
              error={hasError}
            />
          )}
          renderError={renderErrorMessage}
        />
      </FieldWrapper>
      <FieldWrapper>
        <Field
          registrar={registrar}
          name="parentPhoneNum"
          rules={[
            isRequired('Mobile number is required'),
            isLengthMatchError('Please enter a valid mobile number', 10)
          ]}
          render={({ onChange, value, hasError }) => (
            <StyledNumberField
              fullWidth
              startAdornment={
                <InputAdornment>
                  <CountryMenu country={country} disabled />
                </InputAdornment>
              }
              placeholder="Enter mobile number"
              onChange={(_, data) => {
                onChange(data);
                updateStoreData('parentPhoneNum', data);
              }}
              value={value}
              inputProps={{
                type: 'tel',
                maxLength: 10,
                required: true
              }}
              type="tel"
              error={hasError}
            />
          )}
          renderError={renderErrorMessage}
        />
      </FieldWrapper>
      <FieldWrapper>
        <Field
          registrar={registrar}
          name="parentIdType"
          rules={[isRequired('parentIdType is required')]}
          render={({ onChange, value }) => (
            <StyledDropdown
              options={parentIdTypes}
              placeholder="Select your Government ID "
              selectedOption={value || parentIdTypes[0]}
              onOptionClick={(data) => {
                onChange(data);
                updateStoreData('parentIdType', data);
              }}
              buttonWidth="100%"
            />
          )}
          renderError={renderErrorMessage}
        />
      </FieldWrapper>
      <FieldWrapper>
        {parentIdTypeValue === parentIdType && (
          <Field
            registrar={registrar}
            name="parentIdNumber"
            rules={[
              isRequired('parentIdNumber is required'),
              isNumericOnlyError(
                'This ID type cannot have alphabets & special characters'
              ),
              isIdLengthValidError('Enter valid ID number', parentIdTypeValue)
            ]}
            render={({ onChange, value, hasError }) => (
              <StyledTextField
                placeholder="Enter ID number"
                value={value}
                onChange={(e) => {
                  onChange(e.target.value);
                  updateStoreData('parentIdNumber', e.target.value);
                }}
                inputProps={{
                  maxLength: 20,
                  required: true
                }}
                error={hasError}
              />
            )}
            renderError={renderErrorMessage}
          />
        )}
      </FieldWrapper>
      <FormSectionSubHeading>Upload government ID</FormSectionSubHeading>
      <FieldWrapperSmall>
        <Field
          registrar={registrar}
          name="parentId"
          rules={[
            isRequired('Upload the image'),
            isImageTypeValid('Upload an image in .png or .jpg format'),
            isImageSizeValid('Image size should not exceed 10 MB')
          ]}
          render={({ onChange, value, hasError }) => {
            const newValue =
              value && Object.keys(value).length > 0 ? value : null;
            return (
              <FileUploader
                value={newValue}
                error={hasError}
                onOptionClick={(data) => {
                  onChange(data);
                  updateStoreData('parentId', data);
                }}
              />
            );
          }}
          renderError={renderErrorMessage}
        />
      </FieldWrapperSmall>
    </FormContainer>
  );
};

export default ParentDetails;
